import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table } from 'react-bootstrap';
import { authContext } from '../AzureAd';

export default class MaintenanceRefineComponent extends React.Component {

	// constructor(props) {
	// 	super(props);
	// }

	componentDidMount() {
	}

	componentWillMount() {
		this.props.findRefinableMCases();
	}

	refineMaintenanceCase(pk) {
		let ret = confirm("[全部確認] 後清點作業將直接進入維修階段。");
		if (ret) {
			this.props.refineMCase(pk, authContext.getCachedUser().userName);
		}
	}

	modifyMaintenanceCase(mCase) {
		this.props.assignModifyingTarget(mCase);
		hashHistory.push("/refineCards");
	}

	render() {

		let caseStatus = function (statusKey) {
			switch (statusKey) {
				case 'WAITING': return '尚未清點';
				case 'CANCELED': return '已取消';
				case 'CHECKING': return '洗前清點中';
				case 'CHECKED': return '洗前清點完畢';
				case 'MODIFYING': return '修改中';
				case 'REFINED': return '已確認';
				case 'FIXING': return '完成維修';
				case 'AUDITED': return '完成稽核';
				default: return '';
			}
		}

		let alignCenter = {
			textAlign: "center",
			verticalAlign: "middle"
		}

		let roles = this.props.roles.toJS();
		let showCaseFixing = (roles.includes("ROLE_MAINTENANCE_CASE_FIXING"));

		return (
			<div>
				<h4><span hidden> MaintenanceRefineComponent </span>作業開工確認</h4>
				<Table striped bordered condensed hover>
					<thead>
						<tr>
							<th>訂單編號</th>
							<th>客戶</th>
							<th>註記</th>
							<th>建立時間</th>
							<th>修改</th>
							{showCaseFixing && <th>開工</th>}
							<th>狀態</th>
						</tr>
					</thead>
					<tbody>
						{this.props.response.get('cases').map(
							(item, index) =>
								<tr key={index}>
									<td style={alignCenter}>{item.orderId}</td>
									<td style={alignCenter}>{item.customer.customerName}</td>
									<td style={alignCenter}>{item.note}</td>
									<td style={alignCenter}>{new Date(item.createTime).toLocaleDateString()}</td>
									<td style={alignCenter}>
										<Button bsStyle="info" onClick={(event) => { this.modifyMaintenanceCase(item); }} >修改...</Button>
									</td>
									{showCaseFixing &&
										<td style={alignCenter}>
											<Button bsStyle="success" onClick={(event) => { this.refineMaintenanceCase(item.id); }} >開工</Button>
										</td>
									}
									<td style={alignCenter}>{caseStatus(item.status)}</td>
								</tr>
						)}
					</tbody>
				</Table>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceRefineComponent.jsx